// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Lightbox-ImageContainer-module--cls1--222Si","cls2":"Lightbox-ImageContainer-module--cls2--1H8bU Lightbox-ImageContainer-module--cls1--222Si"};